/* eslint-disable no-undef */
const amend = require('amend')

function initialize (amendConfig) {
  const di = amend.fromNodeConfig({
    annotations: amendAnnotation,
    config: amendConfig,
    baseDir: __amendBaseDir,
  })

  di.value('conf', mtConf)

  window.onload = function () {
    di.loadAll()
  }
}

module.exports = initialize
